import React from 'react';

import type { MenuItemLinkElementProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';
import { CoreLink, RecursiveMenu } from '@uncinc/react-drupal-core';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const MenuLi: React.FC<MenuItemLinkElementProps> = ({
  data,
  children,
  ...props
}) => (
  <CoreLink href={props.url} className="RecursiveMenu__title haslink">
    <Icon name={props.title.toLowerCase()} />
  </CoreLink>
);


const SocialMenu = () => (
  <div className="SocialMenu">
    <RecursiveMenu
      menuId="social"
      MenuItemLinkElement={MenuLi}
    />
  </div>
);

export default SocialMenu;
